import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { logger } from 'src/utils';

export interface IPendingReviewUIProps {
  title: string;
  isLoading: boolean;
  onResendEmailClick?: () => Promise<void>;
  onLoadingChange: (loading: boolean) => void;
}

/** @registry Read-only "pending review" panel with an optional resend-email action, shown while a workflow step awaits review. */
export const PendingReviewUI: React.FC<IPendingReviewUIProps> = ({
  title,
  isLoading,
  onResendEmailClick,
  onLoadingChange,
}) => {
  const handleResendEmail = async () => {
    onLoadingChange(true);
    try {
      await onResendEmailClick?.();
    } catch (err) {
      logger.error('Failed to resend email', { err });
    }
    onLoadingChange(false);
  };

  return (
    <Paper withBorder>
      <Stack gap="md">
        <Text ta="center">{title}</Text>
        {onResendEmailClick && (
          <Group justify="center">
            <BasicButton loading={isLoading} onClick={handleResendEmail}>
              Resend Email
            </BasicButton>
          </Group>
        )}
      </Stack>
    </Paper>
  );
};
